import AuthApi from '@api/authentication'
import ChatApi from '@api/chat'
import HUAMAN_API from '@api/hua_man/index.js'
import systemApi from '@api/system'
import homeApi from '@api/xiu_yan/homeApi'
import authenticationModalStore from '@components/LocalMerchant/Home/AuthenticationModal/store'
import chatStore from '@components/LocalMerchant/NoticeChat/Chat/store'
import { appendUrlQuery } from '@core/utils'
import { getObjValue } from '@hlj/hlj-utils'
import { isSiDaProperty } from '@merchant-backend/util'
import { getNameCardRight, getMerchantInfo, getJti } from '@util'
import { Modal } from 'hljd'
import { action, computed, observable } from 'mobx'
import React from 'react'
import PosterStore from './posterStore'
import SocketStore from './socket'
import PanguApi from '@api/pangu'
import { PANGU_HOME } from '@constant'
class Store {
  @observable merchantInfo = {}
  @observable shopInfo = {}
  @observable loading = false
  // 二级菜单是否展开
  @observable subMenuOpen = false
  // 是否接收私信
  @observable is_rev_msg
  // 商家产品权限列表
  @observable productAuth = []
  // 是否开通海草云
  @observable isOpenHcy = false

  /*
    contentMainDiv : contentMain Dom  is_new == 0 时获取
  */
  contentMainDiv = null

  constructor() {
    this.posterStore = new PosterStore()
    this.socketStore = new SocketStore()
  }

  init() {
    // TODO
    this.merchantAction()
    this.getProductAuth()
    this.posterStore.getPosterData()
    this.getIsRecvMsg()
    this.getShopInfo()
    this.getLiteAppFee()
    this.isPay()
    this.getCpmType()
    this.getNameCard() // 获取是否开通海草名片
    this.getOpenHcy()
    this.socketStore.initSocket()
    // 盘古新增逻辑
    // 获取是否是盘古激活商家
    this.getCropJumpMode()
    this.getStoreJumpMode()
  }

  getOpenHcy = async () => {
    const { success, data } = await AuthApi.isOpenHcy()
    if (success) {
      this.isOpenHcy = data == 3
    }
  }

  getProductAuth = async () => {
    const { success, data } = await AuthApi.productAuth()
    if (success) {
      this.productAuth = data || []
    }
  }

  setSubMenuOpen = (isActive) => {
    this.subMenuOpen = isActive
  }

  /**
   * 获取商家信息
   * TODO，这里可以去掉了，只需要在 globalStore 中调一次 edit
   */
  @action
  merchantAction = async () => {
    this.loading = true
    // TODO 调了edit
    const { data, success } = await systemApi.edit()

    this.loading = false

    if (success) {
      this.merchantInfo = data
      sessionStorage.setItem('merchant_info', JSON.stringify(data))
      const { is_four_role_improved, four_role_improve_tip, unbind_data = {}, property_id } = this.merchantInfo

      const { should_unbind } = unbind_data

      if (!should_unbind && is_four_role_improved == 0) {
        Modal.info({
          title: '提示',
          content: (
            <div>
              <p style={{ marginBottom: 10 }}>{getObjValue(four_role_improve_tip, 'index.tip')}</p>
              <p>{getObjValue(four_role_improve_tip, 'index.des')}</p>
            </div>
          ),
          okText: '开始升级',
          onOk: () => {
            // 补全信息优先
            window.location.replace(
              appendUrlQuery('/p/frontend/merchant-center/dist/index.html#/freeShop/chooseType', {
                is_four_role_improved: 1,
                property_id,
              }),
            )
          },
        })
      }
      authenticationModalStore.showAuthModal(data)
    }
  }

  /**
   * 滚动 main 区域至最上方
   */
  scrollTopMain = (x = 0, y = 0) => {
    try {
      const node = this.contentMainDiv.current
      node && node.scrollTo && node.scrollTo(x, y)
    } catch (e) {}
  }

  @action
  getIsRecvMsg = async () => {
    if (!isSiDaProperty()) {
      this.is_rev_msg = 1
    } else {
      const { success, data } = await ChatApi.isReceiveMsg()
      this.is_rev_msg = success ? data : 0
    }

    if (this.is_rev_msg) {
      chatStore.initSocket()
      chatStore.getUnreadLetter('initial')
    }
  }

  getShopInfo = async () => {
    const { data } = await homeApi.shopInfo()
    this.shopInfo = data || {}
  }

  @observable liteAppFee = 0
  getLiteAppFee = async () => {
    const { success, data } = await homeApi.price()
    this.liteAppFee = success ? data : 0
  }

  @observable isPaid = undefined
  @observable isExpired = false
  @observable noPaid = undefined
  isPay = async () => {
    const { data } = await HUAMAN_API.isPay()
    this.isPaid = Boolean(Number(data.is_paid))
    switch (true) {
      case !this.isPaid && !!data.expired_date:
        this.isExpired = true
        break
      case !this.isPaid && !data.expired_date:
        this.noPaid = true
        break
      case !!this.isPaid:
        this.isExpired = false
        break
    }
  }

  //智优投&智推宝的显隐
  @observable cpm_type = 1
  getCpmType = async () => {
    const {
      data: { cpm_type },
      success,
    } = await homeApi.cpm_type()
    if (success) {
      this.cpm_type = cpm_type || 1
    }
  }

  /**
   * 是否是加盟店
   */
  @computed
  get isStore() {
    return this.merchantInfo.is_franchisee == 1
  }

  /**
   * 是否开通海草名片
   */
  @observable nameCardRight = false
  getNameCard = async () => {
    this.nameCardRight = await getNameCardRight()
  }

  /**
   * 是否灰度企业，灰度企业会显示跳转盘古入口
   */

  @observable isGrayCrop = false // 企业是否灰度
  getCropJumpMode = async () => {
    const { corp_id } = getMerchantInfo()
    const { data, success } = await PanguApi.getCropJumpMode({
      cropId: corp_id,
    })
    if (success) {
      this.isGrayCrop = Boolean(data.status)
    }
  }
  /**
   * 是否盘古激活商家，盘古激活商家会直接重定向到盘古地址
   */

  @observable isActiveStore = false // 店铺是否激活
  getStoreJumpMode = async () => {
    const { store_seq_id } = getMerchantInfo()
    const { data, success } = await PanguApi.getStoreJumpMode({
      storeSeqId: store_seq_id,
    })
    if (success) {
      this.isActiveStore = data.status
      if (data.status) {
        // 携带jti重定向至盘古
        window.location.replace(PANGU_HOME + getJti())
      }
    }
  }
}

export default new Store()
